import { useTranslation } from '@/shared/i18n/use-translation';
import { Button } from '@/shared/ui/button/button';

type ChipFilterProps<V extends string> = {
  readonly label: string;
  readonly value: V;
  readonly onChange: (value: V) => void;
  /** Labels are English keys, translated here. */
  readonly options: readonly { readonly value: V; readonly label: string }[];
};

export function ChipFilter<V extends string>({ label, value, onChange, options }: ChipFilterProps<V>) {
  const { t } = useTranslation();
  return (
    <fieldset
      className="no-scrollbar -mx-4 flex gap-1.5 overflow-x-auto px-4 pb-1 md:mx-0 md:px-0"
      aria-label={label}
    >
      {options.map((option) => (
        <Button
          key={option.value}
          size="sm"
          variant={value === option.value ? 'default' : 'outline'}
          className="shrink-0 rounded-full"
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
        >
          {t(option.label)}
        </Button>
      ))}
    </fieldset>
  );
}
